module.exports = __webpack_public_path__ + "static/media/white-trainersflats.f3e0a11e.jpg";